import { render, staticRenderFns } from "./CourseWindow.vue?vue&type=template&id=159ff4d1&"
import script from "./CourseWindow.vue?vue&type=script&lang=js&"
export * from "./CourseWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports